import { IFormFieldOverrideConfig } from './form-field-override-config.interface';

export const FORM_FIELD_OVERRIDE_CONFIGS: IFormFieldOverrideConfig[] = [
  // Intentionally empty in this change. Follow-up tickets will add entries.
];

// Startup check — fails fast on duplicate keys. O(n) over a tiny array; cheap enough to always run.
(function assertNoDuplicates() {
  const seen = new Set<string>();
  for (const c of FORM_FIELD_OVERRIDE_CONFIGS) {
    const key = `${c.country}|${c.deliveryMethod}|${c.fieldId}`;
    if (seen.has(key)) {
      throw new Error(`[FormFieldOverride] duplicate config for ${key}`);
    }
    seen.add(key);
  }
})();



// WEBPACK FOOTER //
// ./src/providers/formbuilder/form-field-override-configs.ts